// @mui
import Container from '@mui/material/Container';
// hooks
// _mock
// components
import { useSettingsContext } from 'src/components/settings';
import GeneralTable from './general-table';
// assets
//

// ----------------------------------------------------------------------

export default function GeneralProduct() {
    // const { user } = useMockedUser();
    const settings = useSettingsContext();
    return (
        <Container maxWidth={ settings.themeStretch ? false : 'xl' }>
            <GeneralTable />
        </Container >
    );
}
